export default __webpack_public_path__ + "static/media/fisher-bear.4e1152a0.svg";